module.exports = __webpack_public_path__ + "static/media/BANNER_WEB.ffcb2aca.png";